import classNames from 'classnames';
import styles from './LiveVideoStreamingButton.module.scss';
import { Icon, IconsEnum } from 'components/Icons';
import { useSelector } from 'react-redux';
import { useAppDispatch } from 'lib/centralStore';
import { callbackOnAuthenticated } from 'utility/auth';
import { useLiveStreaming } from '../liveVideoStreaming/useLiveStreaming';
import { VideoStreamingMode } from '../liveVideoStreaming/types';
import { selectIsStreamingOpen } from 'features/settings/selectors';
import { setIsStreamingOpened } from 'features/settings/settingsSlice';
import { setIsInfoOpen } from 'features/sport/sportSlice';
import { Tooltip, TooltipPosition } from 'components/tooltip';
import { useTranslation } from 'hooks/useLingUI';
import { useInfoTemplateAvvenimento } from 'features/sport/hooks';
import { SportsCacheTemplateAvvenimentoDto } from 'types/swagger';
import { selectIsInfoOpen } from 'features/sport';
import { isTruthy } from 'utility/functions';

export type LiveVideoStreamingButtonProps = {
  className?: string;
};

export const LiveVideoStreamingButton = ({ className }: LiveVideoStreamingButtonProps) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const isInfoOpen = useSelector(selectIsInfoOpen);
  const isStreamingOpen = useSelector(selectIsStreamingOpen);
  const { templateAvvenimento } = useInfoTemplateAvvenimento<SportsCacheTemplateAvvenimentoDto>();

  const { isAuthenticated, isEmpty, isError, setStreamingMode } = useLiveStreaming({
    idProgramma: `${templateAvvenimento?.idProgramma}`,
    idAvvenimento: `${templateAvvenimento?.idAvvenimento}`,
    betRadarMatchId: `${templateAvvenimento?.live?.betRadarMatchId}`,
    betGeniusMatchId: `${templateAvvenimento?.live?.betGeniusMatchId}`,
    hasStreaming: isTruthy(templateAvvenimento?.live?.hasStreaming),
  });

  const onClickHandler = () => {
    callbackOnAuthenticated(isAuthenticated, () => null);
    if (isAuthenticated) {
      if (isInfoOpen && isStreamingOpen) {
        dispatch(setIsStreamingOpened(false));
      } else {
        dispatch(setIsStreamingOpened(!isStreamingOpen));
        dispatch(setIsInfoOpen(false));
      }
      setStreamingMode(!isStreamingOpen ? VideoStreamingMode.minimal : VideoStreamingMode.off);
    }
  };

  return (
    <button
      type="button"
      className={classNames(className ?? '', styles.button, { [styles.open]: isStreamingOpen })}
      onClick={onClickHandler}
    >
      {(isEmpty || isError) && isStreamingOpen ? (
        <Tooltip
          content={t('video-not-available', '#video-not-available')}
          forceActive
          iconId={IconsEnum.STREAMING}
          iconColor={isStreamingOpen ? '--color-surface-01' : '--color-on-bg-primary'}
          position={TooltipPosition.LEFT}
          iconClassName={styles.icon}
        />
      ) : (
        <Icon
          iconId={IconsEnum.STREAMING}
          className={classNames(styles.icon)}
          color={isStreamingOpen ? 'var(--color-surface-01)' : 'var(--color-on-bg-primary)'}
        />
      )}
    </button>
  );
};
